import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { ChainId, type Token } from '../../types';
import { eth } from '../nativeTokens';

export const ethereum: Token[] = [
  eth[ChainId.ETHEREUM],
  {
    chainId: ChainId.ETHEREUM,
    address: '0xd3CC9d8f3689B83c91b7B59cAB4946B063EB894A',
    decimals: 18,
    symbol: 'XVS',
    iconSrc: iconSrcs.xvs,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x7f39c581f595b53c5cb19bd0b3f8da6c935e2ca0',
    decimals: 18,
    symbol: 'wstETH',
    iconSrc: iconSrcs.wstEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    decimals: 8,
    symbol: 'WBTC',
    iconSrc: iconSrcs.wbtc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    decimals: 18,
    symbol: 'WETH',
    iconSrc: iconSrcs.weth,
    tokenWrapped: eth[ChainId.ETHEREUM],
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    decimals: 6,
    symbol: 'USDC',
    iconSrc: iconSrcs.usdc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    decimals: 6,
    symbol: 'USDT',
    iconSrc: iconSrcs.usdt,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E',
    decimals: 18,
    symbol: 'crvUSD',
    iconSrc: iconSrcs.crvUsd,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    decimals: 18,
    symbol: 'CRV',
    iconSrc: iconSrcs.crv,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xcd5fe23c85820f7b72d0926fc9b05b43e359b7ee',
    decimals: 18,
    symbol: 'weETH',
    iconSrc: iconSrcs.weEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x0000000000085d4780B73119b644AE5ecd22b376',
    decimals: 18,
    symbol: 'TUSD',
    iconSrc: iconSrcs.tusd,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x6b175474e89094c44da98b954eedeac495271d0f',
    decimals: 18,
    symbol: 'DAI',
    iconSrc: iconSrcs.dai,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x853d955acef822db058eb8505911ed77f175b99e',
    decimals: 18,
    symbol: 'FRAX',
    iconSrc: iconSrcs.frax,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xa663b02cf0a4b149d2ad41910cb81e23e1c41c32',
    decimals: 18,
    symbol: 'sFRAX',
    iconSrc: iconSrcs.sFrax,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x6ee2b5e19ecba773a352e5b21415dc419a700d1d',
    decimals: 18,
    symbol: 'PT-weETH-DEC24',
    iconSrc: iconSrcs.ptWeeth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7',
    decimals: 18,
    symbol: 'rsETH',
    iconSrc: iconSrcs.rsEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xac3E018457B222d93114458476f3E3416Abbe38F',
    decimals: 18,
    symbol: 'sfrxETH',
    iconSrc: iconSrcs.sfrxEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xbf5495Efe5DB9ce00f80364C8B423567e58d2110',
    decimals: 18,
    symbol: 'ezETH',
    iconSrc: iconSrcs.ezEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x917ceE801a67f933F2e6b33fC0cD1ED2d5909D88',
    decimals: 18,
    symbol: 'weETHs',
    iconSrc: iconSrcs.weeths,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xD9A442856C234a39a81a089C06451EBAa4306a72',
    decimals: 18,
    symbol: 'pufETH',
    iconSrc: iconSrcs.pufEth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xec53bf9167f50cdeb3ae105f56099aaab9061f83',
    decimals: 18,
    symbol: 'EIGEN',
    iconSrc: iconSrcs.eigen,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x657e8c867d8b37dcc18fa4caead9c45eb088c642',
    decimals: 8,
    symbol: 'eBTC',
    iconSrc: iconSrcs.eBtc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x8236a87084f8B84306f72007F36F2618A5634494',
    decimals: 8,
    symbol: 'LBTC',
    iconSrc: iconSrcs.lbtc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    decimals: 18,
    symbol: 'sUSDe',
    iconSrc: iconSrcs.sUsdE,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x8A47b431A7D947c6a3ED6E42d501803615a97EAa',
    decimals: 18,
    symbol: 'PT-USDe-MAR25',
    iconSrc: iconSrcs.ptUsdE,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xE00bd3Df25fb187d6ABBB620b3dfd19839947b81',
    decimals: 18,
    symbol: 'PT-sUSDE-MAR25',
    iconSrc: iconSrcs.ptSUsdE,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xa3931d71877c0e7a3148cb7eb4463524fec27fbd',
    decimals: 18,
    symbol: 'sUSDS',
    iconSrc: iconSrcs.sUsds,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
    decimals: 18,
    symbol: 'USDS',
    iconSrc: iconSrcs.usds,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xba100000625a3754423978a60c9317c58a424e3D',
    decimals: 18,
    symbol: 'BAL',
    iconSrc: iconSrcs.bal,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xBe53A109B494E5c9f97b9Cd39Fe969BE68BF6204',
    decimals: 6,
    symbol: 'yvUSDC-1',
    iconSrc: iconSrcs.yvusdc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x310B7Ea7475A0B449Cfd73bE81522F1B88eFAFaa',
    decimals: 6,
    symbol: 'yvUSDT-1',
    iconSrc: iconSrcs.yvusdt,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x182863131F9a4630fF9E27830d945B1413e347E8',
    decimals: 18,
    symbol: 'yvUSDS-1',
    iconSrc: iconSrcs.yvusds,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0xc56413869c6CDf96496f2b1eF801fEDBdFA7dDB0',
    decimals: 18,
    symbol: 'yvWETH-1',
    iconSrc: iconSrcs.yvweth,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x8A5A5DE9db5770123Ff2145F59e9F20047f0A8EC',
    decimals: 18,
    symbol: 'mtwCARROT',
    iconSrc: iconSrcs.carrot,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x18084fbA666a33d37592fA2633fD49a74DD93a88',
    decimals: 18,
    symbol: 'tBTC',
    iconSrc: iconSrcs.tBtc,
  },
  {
    chainId: ChainId.ETHEREUM,
    address: '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    decimals: 18,
    symbol: 'USDe',
    iconSrc: iconSrcs.usde,
  },
];
